'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';

interface ClosingCTAProps {
  language: 'en' | 'es';
}

const ClosingCTA = ({ language }: ClosingCTAProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('closing-cta');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const content = {
    en: {
      headline: 'Ready to move fast?',
      cta: 'Get Started',
    },
    es: {
      headline: '¿Listo para moverse rápido?',
      cta: 'Empezar',
    },
  };

  return (
    <section id="closing-cta" className="py-20 px-6 bg-foreground">
      <div className="max-w-screen-xl mx-auto text-center">
        <div className={`space-y-8 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-background">
            {content[language].headline}
          </h2>
          <Link
            href="/contact"
            className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-primary-foreground bg-primary sharp hover:scale-105 transition-transform duration-300"
          >
            {content[language].cta}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;